import { COLORS } from '../../config/colors/colors';
import { styled } from 'goober';
import { Tag } from '../tag/tag';
import { Typography } from '../typography/typography';

export const Wrapper = styled('div')<{ isPointer?: boolean }>`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 12px;
    border-radius: 16px;
    border: 1px solid ${COLORS.neutral_20};
    cursor: ${({ isPointer }) => (isPointer ? 'pointer' : 'default')};
`;

export const Title = styled(Typography)`
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
`;

export const StyledTag = styled(Tag)`
    margin-top: 2px;
`;
